// RoleManagement.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import SaveIcon from '@mui/icons-material/Save';

import CancelIcon from '@mui/icons-material/Cancel';

import EditIcon from '@mui/icons-material/Edit';
import {
  
  Autocomplete,
  
  Box,
  useTheme,
  Card,

  Grid,
  Toolbar,
  Button,
  TextField,

  DialogContent,

  Divider,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';



import Header from '../../Layout/Header';
import { tokens } from '../../theme/theme';
// Mock data for demonstration
import CallAlertBar from '../../Layout/Alertbar';

import { API_ENDPOINTS } from '../../config/api/apiCall';
import { callApi } from '../../utils/apiClient';


const AddUpdateCompany = ({ newUser, setNewUser, setIsEditModalOpen, setCompanyList, LoadCompanyDetails,
  setIsSubscriptionModelOpen
}) => {

  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isCountryLoaded, setIsCountryLoaded] = useState(false);
  const [newRole, setNewRole] = useState({ role_id: 0, role_name: '', description: '', isactive: true });
  const [currentRoleId, setCurrentRoleId] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [errorMessages, setErrorMessages] = useState({});
  const [country, setCountry] = useState([]);
  const [milltype, setmilltype] = useState([]);
  const [subscriptionmodel, setsubscriptionmodel] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [billingState, setBillingState] = useState([]);
  const [billingStateID, setBillingStateID] = useState([]);
  const [selectedBillingState, setSelectedBillingState] = useState(null);

  const [billingCity, setBillingCity] = useState([]);
  const [billingCityID, setBillingCityID] = useState([]);
  const [selectedBillingCity, setSelectedBillingCity] = useState(null);
  const [state, setState] = useState([]);

  const [selectedmilltype, setSelectedmilltype] = useState(null);
  const [selectedSubscriptionmodel, setSelectedSubscriptionmodel] = useState(null);
  const [userid, setUserID] = useState('');
  const [fromDate, setSelectedDate] = useState(dayjs());
  const [stateID, setStateID] = useState([]);
  const [city, setCity] = useState([]);

  const [Todate, setTodate] = useState(dayjs());
  const [cityID, setCityID] = useState([]);
  const [billingCountryID, setBillingCountryID] = useState([]);
  const [billingCountry, setBillingCountry] = useState([]);
  const [selectedBillingCountry, setSelectedBillingCountry] = useState(null);
  useEffect(() => {
    const retrievedUserID = localStorage.getItem('userID');
    if (retrievedUserID) {
      setUserID(retrievedUserID);
    }
  }, []); // Empty dependency array to run only once on mount

  const [countryID, setCountryID] = useState([]);



  const callError = (serverityval, msg, title) => {
    // Update state with error message        
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };


  // Function to reset the form
  const resetForm = () => {
    setIsModalOpen(false);
    setNewRole({ role_name: '', description: '', role_id: 0, isactive: 'true' });
    setCurrentRoleId(null);
  };

  useEffect(() => {
    if (billingCountryID && billingCountry.length > 0) {
      const selected = billingCountry.find(c => c.id === billingCountryID);
      if (selected) {
        setSelectedBillingCountry(selected);
      }
    }
  }, [billingCountryID, billingCountry]);

  useEffect(() => {
    if (billingStateID && billingState.length === 0 && billingCountryID && billingCountry.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_countryid: billingCountryID,
      }
      callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setBillingState(data);
            setSelectedState(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }

    if (billingStateID && billingState.length > 0) {
      const selected = billingState.find(c => c.id === billingStateID);
      if (selected) {
        setSelectedBillingState(selected);
      }
    }
  }, [billingStateID, billingState]);

  useEffect(() => {

    if (billingStateID && billingState.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_stateid: billingStateID,
      }
      callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setBillingCity(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
    if (billingCityID && billingCity.length > 0) {
      const selected = billingCity.find(c => c.id === billingCityID);
      if (selected) {
        setSelectedBillingCity(selected);
      }
    }
  }, [billingStateID, billingCityID, billingCity]);

  const LoadRoleList = () => {
    let requestBody = {
      CompanyId: 1,
    };

    callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setUserRoles(data);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user roles data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load user role details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };


  const LoadMilltype = () => {
    callApi(API_ENDPOINTS.COMPANY_Getmilltype, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setmilltype(data);

          const obj = data.find(country => country.milltype === newUser.company_mill_type);
          // Set the selected country
          setSelectedmilltype(obj);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('Mill types not found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load Mill types ');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  const LoadSubscriptionModel = () => {
    callApi(API_ENDPOINTS.COMPANY_GetSubscriptionModelListFunc, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setsubscriptionmodel(data);

          const obj = data.find(country => country.model_name === newUser.company_subcriptionmodel);
          // Set the selected country
          setSelectedSubscriptionmodel(obj);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('Mill types not found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load Mill types ');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  useEffect(() => {

    LoadRoleList();
    LoadMilltype();
    LoadSubscriptionModel();
  }, []);


  const handleBackDashboard = () => {
    //navigate("/CompanyManagement");

    setIsEditModalOpen(false);
    setCompanyList(true);
    setIsSubscriptionModelOpen(false);
  }

  // Function to validate user input


  const validateCompany = (user) => {
    const errors = {};
    if (!user.company_name) {
      errors.company_name = "Company name is required.";
    } else if (!user.company_addr_line1) {
      errors.company_addr_line1 = "Address line 1 is required.";
    } else if (!selectedCountry) {
      errors.company_country = "Country is required.";
    } else if (!user.company_status) {
      errors.company_status = "Status is required.";
    }
    // else if (!user.company_dbname) {
    //   errors.company_dbname = "Database name is required.";
    // }


    else if (fromDate > Todate) {
      errors.fromDate = "From date should be less than to To date.";
    }
    else if (!/\S+@\S+\.\S+/.test(user.company_email)) {
      errors.company_email = "Email is invalid.";
    }


    return errors;
  };

  const handleAddCompany = () => {
    const errors = validateCompany(newUser);

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }

    if (!newUser.company_dbname) {
      newUser.company_dbname = 'papyrus_erp_v1';
    }
    if (!newUser.company_isdbshared) {
      newUser.company_isdbshared = 'false';
    }


    let selectedSubscriptionmodel_modelname = "";
    if (selectedSubscriptionmodel === undefined) {
      selectedSubscriptionmodel_modelname = "";
    }
    else {
      selectedSubscriptionmodel_modelname = selectedSubscriptionmodel.model_name;
    }
    //selectedRoles
    let requestBody = {
      company_id: newUser.company_id,
      company_name: newUser.company_name,
      company_addr_line1: newUser.company_addr_line1,
      company_addr_line2: newUser.company_addr_line2,
      company_addr_line3: newUser.company_addr_line3,
      company_country: selectedCountry.code,
      company_email: newUser.company_email,
      company_status: newUser.company_status,
      company_unit: newUser.company_unit,
      company_licencefrom: newUser.company_licencefrom || fromDate,
      company_licenceto: newUser.company_licenceto || Todate,
      company_mill_type: selectedmilltype.milltype,
      company_subcriptionmodel: selectedSubscriptionmodel_modelname,
      company_dbname: newUser.company_dbname,
      company_isdbshared: newUser.company_isdbshared,
      company_contactperson: newUser.company_contactperson,
      company_contactphone: newUser.company_contactphone,
      p_luser: userid,
      company_identifier: newUser.company_identifier,
      company_tpd: newUser.company_tpd,
      id_country: countryID,
      id_state: stateID,
      id_city: cityID,
      gst_no: newUser.gst_no,
      pin_code: newUser.pin_code,

    };

    callApi(API_ENDPOINTS.COMPANY_addUpdateCompanyDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data
        if (data !== null) {
          setParentRollMessageValue(data);
          setParentRollSeverityvalue('info');
          setParentRollAlertTitleValue('Info');
          setParentRollMsgOpen(true);

          LoadCompanyDetails();
        }
        else {
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(data);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
        }

      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });


  };





  const handlefromDateChange = (date) => {
    setSelectedDate(dayjs(date));
    newUser.company_licencefrom = date;
  };



  const handleToDateChange = (date) => {
    setTodate(dayjs(date));
    newUser.company_licenceto = date;
  };

  const handleCountryChange = (event, value) => {
    setSelectedCountry(value);
    setCountryID(value.id);

    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_countryid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          setState(data);
        }
        else {
          setState([]);
          setSelectedState(null);
          setSelectedBillingState(null);
          setCity([]);
        }
      })
      .catch(error => {
        callError('error', error.message, 'Error');
      });
  };


  const LoadStateListBasedOnSelectedCountry = (countryID) => {
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_countryid: countryID,
    }
    callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          setState(data);
          const selectedState = data.find(state => state.id === newUser.id_state);
          // Set the selected state
          setSelectedState(selectedState);
          setStateID(selectedState.id);
          const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_stateid: selectedState.id,
          }
          callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(cityData => {
              if (cityData && cityData.length > 0) {
                setCity(cityData);
                const selectedCity = cityData.find(city => city.id === newUser.id_city);
                // Set the selected city
                setSelectedCity(selectedCity);
                setCityID(selectedCity.id);
              }
              else {
                setCity([]);
                setSelectedCity(null);
              }
            })
            .catch(error => {
              callError('error', error.message, 'Error');
            });
        }
        else {
          setState([]);
          setSelectedState(null);
          setSelectedBillingState(null);
          setCity([]);
        }
      })
      .catch(error => {
        callError('error', error.message, 'Error');
      });
  }


  const handleMilltypeChange = (event, value) => {
    setSelectedmilltype(value);

  };

  const handleSubscriptioModelChange = (event, value) => {
    setSelectedSubscriptionmodel(value);

  };

  useEffect(() => {
    if (!isCountryLoaded) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setCountry(data);
            if (newUser.company_country) {
  const selectedCountry = data.find(country => country.code === newUser.company_country);
            // Set the selected country
            setSelectedCountry(selectedCountry);
            LoadStateListBasedOnSelectedCountry(selectedCountry.id);
            }

          
          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isCountryLoaded]);

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setStateID(value.id);
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_stateid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setCity(data);
          //setSelectedcountry(data[0]);

        }
        else {

          setCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });

  };

  const handleCityChange = (event, value) => {
    setSelectedCity(value);
    setCityID(value.id);
  };

  return (
    <div>
      <Header title={newUser.company_id ? 'Edit Company' : 'Add Company'} subtitle="" callback={handleBackDashboard} />
      <Divider />

      <CallAlertBar
        parentRollMsgOpen={parentRollMsgOpen}
        setParentRollMsgOpen={setParentRollMsgOpen}
        parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue}
        parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue}
        parentRollMessageValue={parentRollMessageValue}
        setParentRollMessageValue={setParentRollMessageValue}
      />

      <Box open={isModalOpen} onClose={resetForm}>



        <Card sx={{
          margin: '1px',
          backgroundColor: 'transparent', padding: "1px",
        }}>
          <Grid container spacing={{ xs: 2, sm: 2, md: 1, lg: 1, xl: 1 }} alignItems="center">
            <Grid ml={2} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
              <Typography variant="h5" textAlign="left">
                Company Name
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
              <TextField
                margin="dense"
                label="Enter the Company name"
                size='small'
                // sx={{fontSize:'16'}}
                fullWidth
                variant="outlined"
                value={newUser.company_name}
                onChange={(e) => setNewUser({ ...newUser, company_name: e.target.value })}
                required
                error={!!errorMessages.company_name}
                helperText={errorMessages.company_name}
              />

            </Grid>
          </Grid>
        </Card>


        <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
          <Box
            sx={{
              // backgroundColor: colors.primary[700],
              padding: "1px",
              borderRadius: "10px",
              maxHeight: {
                xs: '72vh', // Extra small devices (phones)
                sm: '72vh', // Small devices (tablets)
                md: '74vh', // Medium devices (small laptops)
                lg: '67vh', // Large devices (desktops)
                xl: '82vh', // Extra large devices (large desktops)
              },
              overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: colors.primary[400],
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: colors.blueAccent[600],
                borderRadius: '10px',
                '&:hover': {
                  background: colors.blueAccent[800],
                },
              },
              '&::-webkit-scrollbar-corner': {
                background: colors.primary[700],
              }
            }}>

            <Grid container spacing={{ xs: 2, sm: 2, md: 1, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Unit </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  margin="dense"
                  label="Unit"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_unit}
                  onChange={(e) => setNewUser({ ...newUser, company_unit: e.target.value })}

                  error={!!errorMessages.company_unit}
                  helperText={errorMessages.company_unit}
                />

              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Address Line 1 </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                <TextField
                  margin="dense"
                  label="Enter Address Line1"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_addr_line1}
                  onChange={(e) => setNewUser({ ...newUser, company_addr_line1: e.target.value })}
                  required
                  error={!!errorMessages.company_addr_line1}
                  helperText={errorMessages.company_addr_line1}
                />

              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Address Line 2 </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                <TextField
                  margin="dense"
                  label="Enter Address Line2"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_addr_line2}
                  onChange={(e) => setNewUser({ ...newUser, company_addr_line2: e.target.value })}

                  error={!!errorMessages.company_addr_line2}
                  helperText={errorMessages.company_addr_line2}
                />

              </Grid>
            </Grid>



            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Address Line 3 </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                <TextField
                  margin="dense"
                  label="Enter Address Line3"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_addr_line3}
                  onChange={(e) => setNewUser({ ...newUser, company_addr_line3: e.target.value })}

                  error={!!errorMessages.company_addr_line3}
                  helperText={errorMessages.company_addr_line3}
                />
              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Country
                </Typography>
              </Grid>
              <Grid mt={1} item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>

                <Autocomplete
                  fullWidth
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  size="small"
                  options={country}
                  getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                  renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
                {errorMessages.company_country && <Typography variant="caption" color="error">{errorMessages.company_country}</Typography>}


              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  State
                </Typography>
              </Grid>
              <Grid mt={1} item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <Autocomplete
                  fullWidth
                  value={selectedState}
                  onChange={handleStateChange}
                  size="small"
                  options={state}
                  getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                  renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
                {errorMessages.company_state && <Typography variant="caption" color="error">{errorMessages.company_state}</Typography>}
              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  City
                </Typography>
              </Grid>
              <Grid mt={1} item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <Autocomplete
                  fullWidth
                  value={selectedCity}
                  onChange={handleCityChange}
                  size="small"
                  options={city}
                  getOptionLabel={(option) => `${option.description}`}
                  renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
                {errorMessages.company_city && <Typography variant="caption" color="error">{errorMessages.company_city}</Typography>}
              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Pin Code </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <TextField
                  margin="dense"
                  label="Enter Pin Code"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.pin_code}
                  onChange={(e) => setNewUser({ ...newUser, pin_code: e.target.value })}
                  error={!!errorMessages.pin_code}
                  helperText={errorMessages.pin_code}
                />
              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Contact Person </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextField
                  margin="dense"
                  label="Enter Contact Person"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_contactperson}
                  onChange={(e) => setNewUser({ ...newUser, company_contactperson: e.target.value })}

                  error={!!errorMessages.company_contactperson}
                  helperText={errorMessages.company_contactperson}
                />
              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Phone No. </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  margin="dense"
                  label="Enter Phone No."
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_contactphone}
                  onChange={(e) => setNewUser({ ...newUser, company_contactphone: e.target.value })}

                  error={!!errorMessages.company_contactphone}
                  helperText={errorMessages.company_contactphone}
                />
              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Email </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  margin="dense"
                  label="Enter Email"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_email}
                  onChange={(e) => setNewUser({ ...newUser, company_email: e.target.value })}

                  error={!!errorMessages.company_email}
                  helperText={errorMessages.company_email}
                />
              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  GST No </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  margin="dense"
                  label="Enter GST No"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.gst_no}
                  onChange={(e) => setNewUser({ ...newUser, gst_no: e.target.value })}
                  error={!!errorMessages.gst_no}
                  helperText={errorMessages.gst_no}
                />


              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  TPD </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <TextField
                  margin="dense"
                  label="Enter TPD"
                  size='small'
                  fullWidth
                  variant="outlined"
                  value={newUser.company_tpd}
                  onChange={(e) => setNewUser({ ...newUser, company_tpd: e.target.value })}

                  error={!!errorMessages.company_tpd}
                  helperText={errorMessages.company_tpd}
                />
              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Status </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <FormControl required fullWidth margin="dense" size='small'>
                  <InputLabel>Select Status</InputLabel>
                  <Select

                    value={newUser.company_status}
                    onChange={(e) => setNewUser({ ...newUser, company_status: e.target.value })}
                  >
                    <MenuItem value="true">Active</MenuItem>
                    <MenuItem value="false">Inactive</MenuItem>
                  </Select>
                </FormControl>
                {errorMessages.company_status && <Typography variant="caption" color="error">{errorMessages.company_status}</Typography>}

              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Mill type
                </Typography>
              </Grid>
              <Grid mt={1} item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
                <Autocomplete
                  fullWidth
                  value={selectedmilltype}
                  onChange={handleMilltypeChange}
                  size="small"
                  options={milltype}
                  getOptionLabel={(option) => `${option.milltype}`} // Assuming lot numbers are strings label="Child Roll" 
                  renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
                {errorMessages.role && <Typography variant="caption" color="error">{errorMessages.role}</Typography>}

              </Grid>
            </Grid>


            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  License Date
                </Typography>
              </Grid>


              <Grid mt={1} item xs={12} sm={12} md={1.7} lg={1.7} xl={1.7}>

                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From date"
                      style={{ marginLeft: '10px' }}
                      value={dayjs(newUser.company_licencefrom || fromDate)}
                      format='DD-MMM-YYYY'
                      onChange={(date) => handlefromDateChange(date)}
                      slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                      renderInput={(props) => <TextField {...props} />}
                    />
                  </LocalizationProvider>
                </FormControl>
                {errorMessages.fromDate && <Typography variant="caption" color="error">{errorMessages.fromDate}</Typography>}

              </Grid>

              <Grid mt={1} item xs={12} sm={12} md={0.1} lg={0.1} xl={0.1} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  -
                </Typography>
              </Grid>

              <Grid mt={1} item xs={12} sm={12} md={1.7} lg={1.7} xl={1.7}>

                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To date"
                      style={{ marginLeft: '10px' }}
                      format='DD-MMM-YYYY'
                      value={dayjs(newUser.company_licenceto || Todate)}


                      onChange={(date) => handleToDateChange(date)}
                      slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                      renderInput={(props) => <TextField {...props} />}
                    />
                  </LocalizationProvider>
                </FormControl>
                {errorMessages.Todate && <Typography variant="caption" color="error">{errorMessages.Todate}</Typography>}

              </Grid>
            </Grid>

            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              <Grid mt={1} item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Subscription Model
                </Typography>
              </Grid>
              <Grid mt={1} item xs={12} sm={12} md={2} lg={2} xl={2}>

                <Autocomplete
                  fullWidth
                  value={selectedSubscriptionmodel}
                  onChange={handleSubscriptioModelChange}
                  size="small"
                  options={subscriptionmodel}
                  getOptionLabel={(option) => `${option.model_name}`} // Assuming lot numbers are strings label="Child Roll" 
                  renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
                {errorMessages.role && <Typography variant="caption" color="error">{errorMessages.role}</Typography>}

              </Grid>
            </Grid>



          </Box>
        </DialogContent>
      </Box>

      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
          <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                onClick={handleAddCompany}
                sx={{ textTransform: 'none', marginRight: '5px' }}
                variant='contained'
                color="secondary"
                size='small'
                startIcon={newUser.company_id ? <EditIcon /> : <SaveIcon />}
              >
                {newUser.company_id ? 'Update' : 'Save'}
              </Button>

              <Button
                onClick={resetForm}
                sx={{ textTransform: 'none' }}
                variant='outlined'
                color="secondary"
                size='small'
                startIcon={<CancelIcon />}
              >
                Cancel
              </Button>
            </Toolbar>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddUpdateCompany;
